module.exports = __webpack_public_path__ + "static/media/gu_right@2x.2f5fd5ac.png";